import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import * as assetApi from '../../api/app/assetApi';
import { useTranslation } from '../../contexts/translation';
import { AddFolderToAsset, AssetInputs } from '../../types/app/asset.types';
import { dictionary } from '../../utils/core/dictionary';
interface Props {
  defaultValues?: AssetInputs;
  assetId: number;
  setOpen: any;
}

export function GrafanaCreateFolder({ defaultValues, assetId, setOpen }: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<AddFolderToAsset>();
  const { mutate: mutateCreateFolder } = useMutation(assetApi.grafanaAddFolderForAsset);
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  useEffect(() => {
    reset({ folderName: defaultValues?.name });
  }, [defaultValues]);

  const onSubmit: SubmitHandler<AddFolderToAsset> = (data: AddFolderToAsset) => {
    const requestData = {
      assetId: assetId,
      folderName: data.folderName,
    } as AddFolderToAsset;

    mutateCreateFolder(requestData, {
      onSuccess: () => {
        queryClient.invalidateQueries(['uIdFolderList']);
        queryClient.invalidateQueries(['asset']);
        enqueueSnackbar(dictionary.GRAFANA_FOLDER_CREATED, { variant: 'success' });
        setOpen(false);
      },
      onError: (result) => {
        enqueueSnackbar(`${result}`, { variant: 'error' });
      },
    });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '25vw',
            bgcolor: 'background.paper',
            border: '1px solid #000',
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2" mb={2}>
            {dictionary.GRAFANA_CREATE_FOLDER}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Name"
                {...register('folderName')}
                error={Boolean(errors.folderName)}
                helperText={errors.folderName?.message}
              />
            </Grid>
            <Grid item>
              <Stack spacing={2} direction="row">
                <Button type="button" variant="outlined" onClick={() => setOpen(false)}>
                  {t('general.action-buttons.close')}
                </Button>
                <Button type="submit" variant="contained" color="success">
                  {t('general.action-buttons.create')}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  );
}
